import script from "./HomeAppointmentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAppointmentComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeAppointmentComponent.vue?vue&type=style&index=0&id=a222a000&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-morula\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a222a000"]])

export default __exports__